import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate, useParams, useOutletContext } from 'react-router-dom';

import XIcon from "../../../../../../../assets/images/researcher_app/create/big_x_button.png";


function HeaderCreateMission(props) {

    const navigate = useNavigate();



    return (
        <div className="create-mission-header">
            <div className="create-mission-x-button" onClick={() => navigate("/dashboard")}>
                <img src={XIcon} width={14} height={14} />
            </div>
        </div>
    )
}

export default HeaderCreateMission;